import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Highlight from 'react-highlight';

function PageOptionShell({ title, description = 'page header description goes here...', code, content, children, headerTitle = 'Installation', cardClass = 'card card-borderless mb-3', breadcrumbClass = 'breadcrumb float-xl-end' }) {
	return (<><ol className={breadcrumbClass}><li className="breadcrumb-item"><Link to="/">Home</Link></li><li className="breadcrumb-item"><Link to="/layout/starter">Layout</Link></li><li className="breadcrumb-item active">{title}</li></ol><h1 className="page-header">{title} <small>{description}</small></h1><div className={cardClass}><div className="card-header bg-gray-900"><h4 className="card-header-title text-white">{headerTitle}</h4><div className="card-header-btn"><a href="#/" className="btn btn-xs btn-icon btn-default" data-toggle="card-expand"><i className="fa fa-expand"></i></a><a href="#/" className="btn btn-xs btn-icon btn-success" data-toggle="card-reload"><i className="fa fa-redo"></i></a><a href="#/" className="btn btn-xs btn-icon btn-warning" data-toggle="card-collapse"><i className="fa fa-minus"></i></a><a href="#/" className="btn btn-xs btn-icon btn-danger" data-toggle="card-remove"><i className="fa fa-times"></i></a></div></div><div className="card-body">{content || children}</div>{code && <div className="hljs-container hljs-wrapper rounded-0 rounded-bottom" data-bs-theme="dark"><pre><Highlight className="html">{code}</Highlight></pre></div>}</div></>);
}

function PageWithFooter() {
	const [code, setCode] = useState();

	useEffect(() => {
		fetch('/color-admin/admin/react/assets/data/page-with-footer/code-1.json')
			.then((response) => response.text())
			.then(setCode);
	}, []);

	return (
		<>
			<PageOptionShell
				title="Page with Footer"
				path="/layout/with-footer"
				code={code}
				content={<p>Add the <code>.app-footer</code> element to <code>.app-content</code> container for footer page element.</p>}
			/>
			<div id="footer" className="app-footer mx-0 px-0">
				&copy; 2026 Color Admin Responsive Admin Template - Sean Ngu All Rights Reserved
			</div>
		</>
	);
}

export default PageWithFooter;
